var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row ml-3"}),_vm._l((_vm.rows),function(r){return _c('div',{key:r,staticClass:"row"},_vm._l((_vm.rowColMap[r]),function(c){return _c('div',{key:c,class:'text-center ml-3 mt-4 '+_vm.makeWidth(r, c)},[_c('viz1',{attrs:{"viz1":_vm.vizDataRowCol[r][c][0]}})],1)}),0)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }